import { rest } from "src/common/rest";
import { apiObjUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import {
  delayedNotify2ed,
  ed2delayedNotify,
  EdDelayedNotifyDict,
} from "./EdDelayedNotify";
import { zDelayedNotify } from "./ZDelayedNotify";

export const loadDelayedNotify = async (
  objectId: ZUid,
): Promise<EdDelayedNotifyDict> => {
  if (Number(objectId) < 0) return {};
  const resp = await rest.get(apiObjUrl("/message-template/scheduled"), {
    params: { objectId },
  });
  const list = zDelayedNotify.array().parse(resp.data);
  return delayedNotify2ed(list);
};

export const saveDelayedNotify = async (
  objectId: ZUid,
  dict: EdDelayedNotifyDict,
): Promise<void> => {
  const list = ed2delayedNotify(dict);
  await rest.post(apiObjUrl("/message-template/scheduled"), list, {
    params: { objectId },
  });
};
